<template>
    <div class="panel panel-default">
        <div class="panel-heading">{{titre}}
        </div>
        <div class="panel-body">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
  name: 'section-panel-info',
  props: ['titre'],
};
</script>

<style scoped>

</style>
